import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FaTimes } from "react-icons/fa";
import CompanyFormsDialogSelect from "./CompanyFormsDialogSelect";

export default function CompanyFormsEditFormModal({
  open,
  form,
  categories,
  destinations,
  canChangeCategory,
  canChangeDestination,
  canDeleteForm,
  submitting,
  onClose,
  onSave,
  onDeleteForm,
}) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [destinationCountry, setDestinationCountry] = useState("");

  useEffect(() => {
    if (!open || !form) return;
    setName(form.name || "");
    setDescription(form.description || "");
    setCategory(form.category || categories[0]?.value || "");
    setDestinationCountry(
      form.destination_country || destinations[0] || "Global",
    );
  }, [open, form, categories, destinations]);

  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open || !form) return null;

  return createPortal(
    <div className="tailwind-container">
      <div
        className="fixed inset-0"
        style={{ zIndex: 1060, backgroundColor: "rgba(0, 0, 0, 0.55)" }}
        onMouseDown={onClose}
        aria-hidden="true"
      />
      <div
        className="company-forms-modal-overlay tailwind-container company-forms-root"
        style={{ zIndex: 1070 }}
      >
      <div
        className="company-forms-dialog overflow-y-auto bg-white shadow-xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="edit-form-title"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="company-forms-dialog-header">
          <h2 id="edit-form-title" className="company-forms-dialog-title">
            Edit document
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="company-forms-dialog-close"
            aria-label="Close"
          >
            <FaTimes size={12} />
          </button>
        </div>
        <div className="company-forms-dialog-body">
          <div className="company-forms-dialog-fields">
          {(canChangeCategory || canChangeDestination) ? (
            <div className="company-forms-dialog-grid-2">
              {canChangeCategory ? (
                <CompanyFormsDialogSelect
                  id="edit-form-category"
                  label="Category"
                  value={category}
                  onChange={setCategory}
                  options={categories}
                />
              ) : null}
              {canChangeDestination ? (
                <CompanyFormsDialogSelect
                  id="edit-form-destination"
                  label="Destination country"
                  value={destinationCountry}
                  onChange={setDestinationCountry}
                  options={destinations || []}
                />
              ) : null}
            </div>
          ) : null}
          <div>
            <label className="company-forms-dialog-label" htmlFor="edit-form-name">
              Name
            </label>
            <input
              id="edit-form-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="company-forms-dialog-control"
            />
          </div>
          <div>
            <label className="company-forms-dialog-label" htmlFor="edit-form-description">
              Description
            </label>
            <textarea
              id="edit-form-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={2}
              className="company-forms-dialog-control"
            />
          </div>
          </div>
        </div>
        <div className="company-forms-dialog-footer flex-wrap justify-between">
          {canDeleteForm ? (
            <button
              type="button"
              disabled={submitting}
              onClick={onDeleteForm}
              className="company-forms-btn rounded-md px-2.5 py-1.5 text-xs font-semibold text-red-600 ring-1 ring-red-200 hover:bg-red-50"
              style={{ background: "white" }}
            >
              Delete document
            </button>
          ) : (
            <span />
          )}
          <div className="flex gap-2">
          <button
            type="button"
            onClick={onClose}
            className="company-forms-btn rounded-md px-3 py-1.5 text-xs font-semibold text-slate-600 hover:bg-slate-100"
            style={{ border: "none" }}
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={submitting || !name.trim()}
            onClick={() =>
              onSave({
                name: name.trim(),
                description: description.trim(),
                category: canChangeCategory ? category : undefined,
                destination_country: canChangeDestination ? destinationCountry : undefined,
              })
            }
            className="company-forms-btn rounded-md bg-[#007BFF] px-3 py-1.5 text-xs font-semibold text-white hover:bg-[#0069d9] disabled:opacity-60"
            style={{ border: "none" }}
          >
            {submitting ? "Saving…" : "Save changes"}
          </button>
          </div>
        </div>
      </div>
      </div>
    </div>,
    document.body,
  );
}
